var map = {
	"./de/mechaName.png": "vQeg",
	"./en/mechaName.png": "O9n2",
	"./es/mechaName.png": "j5JN",
	"./fr/mechaName.png": "7pW6",
	"./ja/mechaName.png": "LSnw",
	"./ko/mechaName.png": "a/zY",
	"./pt/mechaName.png": "Jumc",
	"./ru/mechaName.png": "S/TZ",
	"./tc/mechaName.png": "c4Oo",
	"./th/mechaName.png": "HHQu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZpD/";